import React from 'react';

type ConsolePaginationProps = {
  currentPage: number;
  totalPages: number;
  onChange: (page: number) => void;
};

const buildPages = (currentPage: number, totalPages: number) => {
  if (totalPages <= 5) {
    return Array.from({ length: totalPages }, (_, index) => index + 1);
  }

  if (currentPage <= 3) {
    return [1, 2, 3, 4, totalPages];
  }

  if (currentPage >= totalPages - 2) {
    return [1, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
  }

  return [1, currentPage - 1, currentPage, currentPage + 1, totalPages];
};

const ConsolePagination: React.FC<ConsolePaginationProps> = ({
  currentPage,
  totalPages,
  onChange,
}) => {
  if (totalPages <= 1) return null;

  const pages = buildPages(currentPage, totalPages);

  return (
    <div className="content-console-pagination">
      <button
        type="button"
        className="content-console-pagination-arrow"
        onClick={() => onChange(Math.max(1, currentPage - 1))}
        disabled={currentPage === 1}
      >
        上一页
      </button>

      <div className="content-console-pagination-pages">
        {pages.map((page, index) => {
          const previous = pages[index - 1];
          const showGap = typeof previous === 'number' && page - previous > 1;

          return (
            <React.Fragment key={page}>
              {showGap ? <span className="content-console-pagination-gap">...</span> : null}
              <button
                type="button"
                className={`content-console-pagination-page${page === currentPage ? ' is-active' : ''}`}
                onClick={() => onChange(page)}
              >
                {page}
              </button>
            </React.Fragment>
          );
        })}
      </div>

      <button
        type="button"
        className="content-console-pagination-arrow"
        onClick={() => onChange(Math.min(totalPages, currentPage + 1))}
        disabled={currentPage === totalPages}
      >
        下一页
      </button>
    </div>
  );
};

export default ConsolePagination;
